export default __webpack_public_path__ + "static/media/notificationapi-logo-black-vertical.5091fec6.png";